module.exports = __webpack_public_path__ + "media/images/lb/345-c73e732a0c4532fff5494cfc1bcc1aea.svg";